import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyClS9Y5gyINpmqt7ImsKMYoy6C1TACtNgQ',
  authDomain: 'newmat-e177d.firebaseapp.com',
  databaseURL: 'https://newmat-e177d.firebaseio.com',
  projectId: 'newmat-e177d',
  storageBucket: 'newmat-e177d.appspot.com',
  messagingSenderId: '33163022100',
  appId: '1:33163022100:web:699d1d04c3e922bdc17c01'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

export const db = firebaseApp.firestore()

export const auth = firebaseApp.auth()

export const storage = firebaseApp.storage()

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }
